import React, { useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import me from "../img/me.jpg";
import COLORS from "../styled.constants";
import { Link } from "react-scroll";
import { faHtml5 } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

function About() {
  const navigate = useNavigate();

  // const redirect = () => {
  //   history.push("/skills");
  // };
  const PageTransition = styled(motion.div)``;
  const AboutSectionStyle = styled.div`
    width: 80%;
    height: 100vh;
    padding-top: 2rem;
    .container {
      display: flex;
      align-items: center;
      /* justify-content: flex-start; */
      width: 100%;
      height: 100vh;
    }
    .about--left {
      /* background-color: blue; */
      flex: 1;
      width: 100%;
      margin: 0 auto;
      /* height: 70%; */
      height: 50vh;
      margin: 3rem 5rem;
      /* position: relative; */
      max-width: 400px;
    }
    .about--right {
      flex: 2;
      /* height: 70%; */
      /* text-align: center; */
      /* max-width: 60%; */
      padding: 1.4rem;
      line-height: 2.8rem;
      margin-top: 0;
      .name {
        font-size: 3em;
        color: ${COLORS.title};
        margin-bottom: 1.8rem;
        font-weight: lighter;
        display: flex;
        justify-content: left;
      }
      .sub-title {
        font-size: 1.8em;
        font-weight: 700;
        color: ${COLORS.text};
        margin-bottom: 1.5rem;
        display: flex;
        justify-content: left;
        width: 100%;
      }
      .text {
        font-size: 1.5em;
        color: ${COLORS.text};
        float: left;
      }
      .text-sub {
        width: 100%;
        text-align: center;
      }
    }
    .profile_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 20px;
      box-shadow: 6px -1px 20px 0px rgba(0, 0, 0, 0.45);
    }

    .greeting {
      width: 100%;
      text-align: center;
    }

    @media only screen and (max-width: 1024px) {
      .container {
        flex-direction: column;
        text-align: center;
        width: 100%;

        .scroll-down {
          bottom: 10px;
          position: fixed;
        }
        .name {
          width: 100%;
          font-size: 2em;
        }
        .sub-title {
          font-size: 1.5em;
          line-height: 2rem;
        }
        .text {
          font-size: 1.3em;
          display: flex;
          align-items: center;
          line-height: 1.8rem;
        }
      }
      .about_left {
        position: absolute;
        left: 0;
        /* width: 100%;
        height: 100%; */
      }
      .about_right {
        width: 100%;
        /* width: 100%;
        height: 100%; */
      }
      .profile_img {
        margin-top: 3rem;
        height: 80%;
        width: 80%;
      }
    }
    @media only screen and (max-width: 768px) {
      .greeting {
        font-size: 30px;
      }
      .text-sub {
        font-size: 25px;
      }
      .text-detail {
        font-size: 17px;
        text-align: justify;
        line-height: 1.2rem;
      }
    }
  `;

  const SkillButton = styled.div`
    position: relative;
    /* display: flex;
    justify-content: center; */
    /* margin: 0 auto;
    margin-top: 1rem;
    padding: 1.2rem;
    width: 100px; */

    .scroll-down {
      cursor: pointer;
      opacity: 1;
      -webkit-transition: all 0.5s ease-in 3s;
      transition: all 0.5s ease-in 3s;
    }
    .scroll-down {
      position: absolute;
      bottom: -350px;
      left: 50%;
      margin-left: -16px;
      margin-bottom: 30px;
      display: block;
      width: 50px;
      height: 50px;
      border: 2px solid ${COLORS.button};
      background-color: ${COLORS.button};
      background-size: 14px auto;
      border-radius: 50%;
      z-index: 2;
      -webkit-animation: bounce 2s infinite 2s;
      animation: bounce 2s infinite 2s;
      -webkit-transition: all 0.2s ease-in;
      transition: all 0.2s ease-in;
    }

    .scroll-down:before {
      position: absolute;
      top: calc(50% - 8px);
      left: calc(50% - 6px);
      transform: rotate(-45deg);
      display: block;
      width: 12px;
      height: 12px;
      content: "";
      border: 2px solid white;
      border-width: 0px 0 2px 2px;
    }
    .scroll-down:hover {
      scale: 3;
      opacity: 0.8;
    }

    @keyframes bounce {
      0%,
      100%,
      20%,
      50%,
      80% {
        -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
      }
      40% {
        -webkit-transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        transform: translateY(-10px);
      }
      60% {
        -webkit-transform: translateY(-5px);
        -ms-transform: translateY(-5px);
        transform: translateY(-5px);
      }
    }
  `;

  return (
    <PageTransition
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <AboutSectionStyle>
        <div className="container">
          <div className="about--left">
            <div className="profile--img">
              <img src={me} alt="profile" className="profile_img" />
            </div>
          </div>
          <div className="about--right">
            <div className="intro">
              <div className="name">
                <div className="greeting">Hey, I am Alisha</div>
              </div>
              <div className="sub-title">
                <div className="text-sub">
                  Full stack developer based in Oslo
                </div>
              </div>
              <div className="text">
                <div className="text-detail">
                  My background is education, data analysis and statistics and{" "}
                  {/* <br /> */}
                  now I returned a programmer. I enjoy creating things and focus
                  on usefulness and elegance. Other than coding, I love
                  swimming.
                </div>
              </div>
              <SkillButton>
                <button
                  className="scroll-down"
                  onClick={() => {
                    navigate("/skills");
                  }}
                ></button>
              </SkillButton>
            </div>
          </div>
        </div>
      </AboutSectionStyle>
    </PageTransition>
  );
}

export default About;
